import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import router from './router'; // Import router from the new file

// BootstrapVue imports
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue/dist/bootstrap-vue.esm';
import VueGtag from "vue-gtag";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.config.productionTip = false;

// Analytics setup
if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  // no analytics in debug mode
} else {
  Vue.use(VueGtag, {
    config: { id: "G-5D1P8EDRD6" }
  }, router);
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
